export default [
  {
    value: 'Wallet',
    text: 'Saldo carteira',
  },
  {
    value: 'Pix',
    text: 'PIX',
  },
  {
    value: 'CreditCard',
    text: 'Cartão crédito',
  },
  {
    value: 'DebitCard',
    text: 'Cartão débito',
  },
  {
    value: 'PostPaid',
    text: 'Pós pago',
  },
];
